import HtmlElement from './HtmlElement';
import { $window } from '../Constants';

/**
 * Main
 *
 * @return Array
 */
const Main = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		MAIN: '.main',
		BACKGROUND_VIDEO: '.main-background-video',
		BACKGROUND_VIDEO_INNER: '.main-background-video-inner',
		BACKGROUND_VIDEO_ELEMENT: '.main-background-video-element',
	};

	/**
	 * ClassName
	 *
	 * @var { Object }
	 */
	const ClassName = {};

	/**
	 * Base URIs for video services like youtube or vimeo
	 *
	 * @var { Object }
	 */
	const VideoBaseUri = {
		YOUTUBE: 'https://www.youtube-nocookie.com/embed/',
		VIMEO: 'https://player.vimeo.com/video/'
	};

	/**
	 * Main
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Main extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.$backgroundVideo = this.$element.find(Selector.BACKGROUND_VIDEO);
			this.$backgroundVideoInner = this.$element.find(Selector.BACKGROUND_VIDEO_INNER);
			this.$backgroundVideoElement = this.$element.find(Selector.BACKGROUND_VIDEO_ELEMENT);
			this.isVideoInitialized = false;
			this.isVideoHidden = false;
			this.ratio = 1.77777777778; // 16:9

			if (this.$backgroundVideo.length) {
				//this._adjustBackgroundVideoSize();

				/*$window.on('resize', () => {
					this._adjustBackgroundVideoSize();
				});*/

				if (this.$backgroundVideoElement.length) {
					this._handleBackgroundVideo();

					$window.on('resize', () => {
						this._handleBackgroundVideo();
					});
				}
			}
		}

		// Private

		_handleBackgroundVideo() {
			if ($window.width() >= 640) {
				if (!this.isVideoInitialized) {
					this._initializeBackgroundVideo();
				} else if (this.isVideoHidden) {
					this._showBackgroundVideo();
				}
			} else {
				if (this.isVideoInitialized && !this.isVideoHidden) {
					this._hideBackgroundVideo();
				}
			}
		}

		_initializeBackgroundVideo() {
			const videoType = this.$backgroundVideoElement.data('type');
			const videoId = this.$backgroundVideoElement.data('id');
			const videoParams = this.$backgroundVideoElement.data('params');

			if (videoType !== 'mp4') {
				const videoUri = VideoBaseUri[videoType.toUpperCase()];
				let videoParamsString = '';

				Object.keys(videoParams).forEach((key, index) => {
					if (index === 0) {
						videoParamsString += '?';
					} else {
						videoParamsString += '&';
					}

					videoParamsString += `${key}=${videoParams[key]}`;
				});

				const $video = $(`<iframe src="${videoUri}${videoId}${videoParamsString}" allowfullscreen allow="autoplay;fullscreen"></iframe>`);
				this.$backgroundVideoElement.append($video);
				this.isVideoInitialized = true;
			} else {
				const videoUri = this.$backgroundVideoElement.data('uri');
				let videoParamsString = '';

				Object.keys(videoParams).forEach((key) => {
					if (videoParams[key] == 1) {
						videoParamsString += ` ${key}`;
					}
				});

				const $video = $(`<video playsinline${videoParamsString}><source src="${videoUri}" type="video/mp4"></video>`);
				this.$backgroundVideoElement.append($video);
				this.isVideoInitialized = true;
			}
		}

		_adjustBackgroundVideoSize() {
			this.$backgroundVideoInner.css('height', this.$element.outerHeight() * this.ratio);
		}

		_hideBackgroundVideo() {
			this.$backgroundVideoElement.css('display', 'none');
			this.isVideoHidden = true;
		}

		_showBackgroundVideo() {
			this.$backgroundVideoElement.css('display', 'block');
			this.isVideoHidden = false;
		}
	}

	return Main._getElements(Selector.MAIN, Main);
})();

export default Main;
